var map = {
	"./close.png": 21958,
	"./gap.png": 2402,
	"./hide.svg": 24300,
	"./hide2.svg": 2966,
	"./location.svg": 3465,
	"./open.svg": 62700,
	"./table_bg.png": 59062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30482;